export default __webpack_public_path__ + "static/giphy-search-clone-00ea1dd2de0866a425aefefb383e8f0d.png";